export default class FormDataWithToken extends FormData {
    constructor() {
        super()

        const rvfEl = document.querySelector<HTMLInputElement>('[name=__RequestVerificationToken]')

        if (rvfEl) {
            this.append('__RequestVerificationToken', rvfEl.value)
        }
    }
}